import { clearAuthTokens } from 'axios-jwt';
import React, { useEffect } from 'react';

import PageLoader from 'components/PageLoader';
import { useLayoutStore } from 'store/layout';
import { login } from 'utils/_utils/session';

import { fetchPartnerTheme } from 'utils/themeUtils';
import pkg from '../../../package.json';

const AppLoader: React.FC = () => {
  const setLoading = useLayoutStore(store => store.setLoading);

  useEffect(() => {
    // Check if there was an update to the app, and if so, logout the user
    if (localStorage.getItem('sc_version') !== pkg.version) {
      clearAuthTokens();
      localStorage.setItem('sc_version', pkg.version);
    }

    Promise.allSettled([login(), fetchPartnerTheme()]).then(() => setLoading(false));
  }, []);

  return <PageLoader />;
};

export default AppLoader;
